import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import './cms-content.css';

// Parse editor HTML before sanitizing it. Do not allow script, style, event
// handlers, embeds or arbitrary classes from saved CMS content.
export const cmsSchema = {
  ...defaultSchema,
  tagNames: [...defaultSchema.tagNames, 'u'],
  attributes: {
    ...defaultSchema.attributes,
    '*': [...defaultSchema.attributes['*'], ['className', /^ql-align-(center|right|justify)$/, /^ql-indent-[1-8]$/]],
  },
};

export const cmsRehypePlugins = [rehypeRaw, [rehypeSanitize, cmsSchema]];

export default function CmsRichText({ content, className = '', style = undefined }) {
  if (!content) return null;
  return <div className={`cms-rich-text prose prose-slate max-w-none ${className}`} style={style}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={cmsRehypePlugins}
      components={{ h1: ({node, children, ...props}) => <h2 {...props}>{children}</h2> }}>
      {String(content)}
    </ReactMarkdown>
  </div>;
}
